// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__279Nl","edit_section":"style_edit_section__1vmZF"};